import * as React from 'react';
import { SVGProps } from 'react';

const IconFoldersSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2H6a2 2 0 0 1-2-2V9z" />
    <path d="M8 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-6a2 2 0 0 0-2-2H8z" />
  </svg>
);
export default IconFoldersSizeM;
